<h3 mat-dialog-title>{{data.title}}</h3>

<mat-dialog-content>
  <div [innerHTML]="data.message"></div>

  <form [formGroup]="forgotPassForm" class="mb-4 mt-2">
      <mat-form-field class="w-100">
        <input matInput id="email" autocomplete="email" formControlName="email" placeholder="{{'FORM.signinForm.EMAIL' | translate}}" required>
        <mat-error *ngIf="forgotPassForm.get('email').errors?.required"> {{ 'FORM_VALIDATION.REQUIRED' | translate }} </mat-error>
        <mat-error *ngIf="forgotPassForm.get('email').errors?.email">{{ 'FORM_VALIDATION.INVALID_FORMAT' | translate }}</mat-error>
      </mat-form-field>
  </form> 
</mat-dialog-content>


<mat-dialog-actions>
    <button mat-button (click)="onCancle()" class="second-btn">{{'gen_dialog_btn_cancle' | translate}}</button>
    <button mat-button cdkFocusInitial class="first-btn" (click)="onConfirm()" [disabled]="forgotPassForm.invalid">{{'gen_dialog_btn_ok' | translate}}</button>
</mat-dialog-actions>